import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoiceButtons from '@/views/my-projects/components/invoice/InvoiceButtons.vue';
import InvoiceAddressData from '@/views/my-projects/components/invoice/addressdata/InvoiceAddressData.vue';
import InvoicePaymentData from '@/views/my-projects/components/invoice/paymentdata/InvoicePaymentData.vue';
import InvoiceBasisData from '@/views/my-projects/components/invoice/basisdata/InvoiceBasisData.vue';
import InvoiceTexts from '@/views/my-projects/components/invoice/texts/InvoiceTexts.vue';
import InvoicePositions from '@/views/my-projects/components/invoice/positions/InvoicePositions.vue';
import InvoiceAttachments from '@/views/my-projects/components/invoice/attachments/InvoiceAttachments.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsInvoice',
  setup(__props) {


return { __sfc: true,MyProjectsSection, InvoiceButtons, InvoiceAddressData, InvoicePaymentData, InvoiceBasisData, InvoiceTexts, InvoicePositions, InvoiceAttachments }
}

})